import { render, staticRenderFns } from "./NewRestaurantGroupModal.vue?vue&type=template&id=2ad32a61&scoped=true&"
import script from "./NewRestaurantGroupModal.vue?vue&type=script&lang=js&"
export * from "./NewRestaurantGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./NewRestaurantGroupModal.vue?vue&type=style&index=0&id=2ad32a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad32a61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDialog,VIcon,VSelect,VTextField})
